<template>  
  <v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>


    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> {{ modoText }}   </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>


    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
    >
      <v-text-field
        v-model="usuario.nomper"
        :counter="50"
        :rules="nameRules"
        label="Nombre"
        required
      ></v-text-field>

      <!-- :readonly="readonly" -->
      <v-text-field
        v-model="usuario.nomuser"
        :counter="15"
        label="Nombre de usuario"
      ></v-text-field>

      <!-- :readonly="readonly" -->
      <v-text-field
        v-model="usuario.email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
<!-- 
      <v-select
        v-model="usuario.nivel"
        :items="niveles"
        :rules="[v => !!v || '*Requerido']"
        label="Nivel"
        required
      ></v-select> -->

      <v-autocomplete
        :items="niveles" 
        v-model="nivel" 
        item-text="nombre" 
        item-value="id" 
        label="Niveles" 
        return-object 
        :rules="[v => !!v || '*Requerido']"
        required
      ></v-autocomplete>

      <v-autocomplete
        :items="bodegas" 
        v-model="bodega" 
        item-text="nombre" 
        item-value="idbodegas" 
        label="Bodegas" 
        return-object
        v-if="mostrarBodega"
        :required="mostrarBodega"
      ></v-autocomplete>

      <v-text-field
        v-if="nModo == 1"
        v-model="usuario.password"
        prepend-icon="lock"
        :append-icon="show1 ? 'visibility' : 'visibility_off'"
        :type="show1 ? 'text' : 'password'"
        label="contraseña"
        hint="Máximo 30 caracteres"
        :counter="30"
        required
        @click:append="show1 = !show1"
      ></v-text-field>

      <v-radio-group v-model="usuario.estatus" row v-if="nModo == 2">
        <v-radio label="Inactivo" :value="0"></v-radio>
        <v-radio label="Activo" :value="2"></v-radio>
        <v-radio label="Baja" :value="3"></v-radio>
      </v-radio-group>
      <!-- <v-btn
        color="error"
        class="mr-4"
        @click="reset"
      >
        Limpiar campos
      </v-btn> -->

    </v-form>
    <div class="mt-10"></div>

    <v-footer absolute>
      <v-spacer></v-spacer>
      <v-btn
        v-if="nModo == 1"
        :disabled="!valid"
        color="primary"
        class="mr-4"
        @click="validar()"
      >
        Agregar
      </v-btn>
      <v-btn
        v-if="nModo == 2"
        :disabled="!valid"
        color="primary"
        @click="update()"
      >
        Actualizar
      </v-btn>
    </v-footer>

    <overlay v-if="overlay"/>

   
  </v-container>
</template>


<script>

  import {mapActions , mapGetters} from 'vuex'
  import overlay from '@/components/overlay.vue'
  import  metodos from '@/mixins/metodos.js';

  var accounting = require("accounting");
  var md5     = require('md5');

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
    props:[
			'parametros',
	  ],
    
    data () {
      return {
        idusuariosweb:'',
        nModo:'',
        modoText:'',
        usuario:[],

        readonly: false,

        niveles: [],
        bodegas:[],
        bodega:{idbodegas:null, nombre:''},
        nivel:{ id: null, nombre: ''},

        mostrarBodega:false,

        snackbar: false,  
        error: '',
        color:'',
        text:'', 

        show1: false,


        valid: true,
        name: '',
        nameRules: [
          v => !!v || '*Requerido',
          v => (v && v.length <= 50) || 'Máximo 50 caracteres',
        ],
        emailRules: [
          v => !!v || '*Requerido',
          v => /.+@.+\..+/.test(v) || 'email no valido',
        ],
        lazy: false,
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,


      }
    },


    watch:{
			parametros(){
        console.log('parametros', this.parametros);
        // this.nivel = { id:null, nombre:''};
        // this.bodega = {idbodegas:null, nombre:''};
				this.initialize();
			},

      nivel(){
        if(!this.nivel) return ;

        if([3,4].includes(this.nivel.id)){
          console.log('mostrar bodega');
          this.mostrarBodega = true
        }else{
          this.mostrarBodega = false
          this.bodega={idbodegas:null, nombre:''}
        }
      }
    },

    async created () {
      this.initialize();
      this.niveles = await this.consultar_niveles();
      this.bodegas = await this.consultar_bodegas();

    },

    methods:{
      ...mapActions('Login',['validarUser']),
      ...mapActions('Login',['GetInfoUser' ,]),

      initialize(){
        this.idusuariosweb = this.parametros.idusuariosweb
        // console.log(this.id)
        if (this.idusuariosweb !== undefined){
          this.nModo = 2
          // console.log("es LA CATEEGO :",this.idCatego)
          this.cargarinfo(this.idusuariosweb) 
          this.readonly = true    
        } else {
          this.nModo = 1
        }     

        this.nModo == 1 ? (this.modoText = 'Nuevo Usuario'):(this.modoText = 'Editar usuario')
      },
      // CARGAR INFO 
      cargarinfo(id){
        this.$http.get('users/' + id).then(response => {
          this.usuario = response.body;
          this.nivel = {id : this.usuario.idniveles, codigo: this.usuario.nivel }
          this.bodega = { idbodegas : this.usuario.idbodegas} 
        }).catch(error=>{
            console.log(error)
        })

      },

      validar(){
        if (this.nModo == 1) {
          this.validarExistencia()
        }  else {
          var me = this 
          this.$http.put('auth/api/v1/usuarios.update/'+ this.usuario.idusuariosweb, payload).then(response => {
            // console.log('response', response.body)
            this.snackbar = true ; this.color="blue lighten-3"
            this.text = "El usuario de modifico correctamente."
            setTimeout(function(){ me.$router.push({name: 'catusuarios'}) }, 2000);
          }).catch(error=>{
            console.log(error)
          })

        }
      },

      validarExistencia(){
        var payload = {
          nomuser  : this.usuario.nomuser,
          nomper   : this.usuario.nomper,
          email    : this.usuario.email,
          password : md5(this.usuario.password),
          nivel    : this.usuario.nivel,
          estatus  : 0
        }

        this.$http.post('user.email', payload).then(respuesta=>{
          console.log('respuesta getId',respuesta)
          if(respuesta.body.message){
            this.newUsuario(payload)
          }else{
            console.log('no agregar')
            if(respuesta.body.email == this.usuario.email){
              this.text = 'El correo que quieres registrar ya existe'
              this.color = 'red'
              this.snackbar = true
            }

            if(respuesta.body.nomuser == this.usuario.nomuser){
              this.text = 'El correo que quieres registrar ya existe'
              this.color = 'red'
              this.snackbar = true
            }
          }
        })
      },

      newUsuario(payload){
        this.$http.post('user.add', payload).then( response => {
          this.enviarCorreo(response.body.id)
          this.snackbar = true
          this.color = "blue lighten-3"
          this.text = "El usuario se guardo correctamente."
        }).catch(error => {
          console.log(error.body)
        })
      },

      enviarCorreo(id){
        var url = this.$http.options.root.substr(0,this.$http.options.root.length -6)+'/admin-app/#/activarusuario/'

        var payload = {
          nomper:       this.usuario.nomper,
          correo:       this.usuario.email,
          url:          url + id
        }

        this.$http.post('correos.send',  payload).then(respuesta=>{ 
          console.log(respuesta)
          this.text = 'Se envío un correo de validación'
          this.color = 'success'
          this.snackbar = true
        }).catch(error=>{
          console.log('error',error)
          resolve(false)
        })
      },

      update(){
        this.overlay = true;
        this.usuario.idniveles = this.nivel.id
        this.usuario.nivel = this.nivel.codigo
        this.usuario.idbodegas = this.bodega.id != null ? this.usuario.idbodegas : this.bodega.idbodegas;

        this.$http.put('updateuser/' + this.usuario.idusuariosweb, this.usuario).then( response => {
          var that = this;
          this.alerta = { activo: true, color:'success', texto :"El usuario se actualizo correctamente."}
          this.cargarinfo(this.usuario.idusuariosweb);
          setTimeout(() => { 
            that.$emit('modal') ;
            that.$emit('init')
          }, 1000);
          
        }).catch(error => {
          console.log(error.body)
        }).finally(()=>{
          this.overlay = false
        })
      },

      reset () {
        this.$refs.form.reset()
      },

    }
  };
</script>




